var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "flex justify-between items-stretch shadow-border-b mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Info Partner")]), _c('div', {
    staticClass: "mb-6 max-w-sm"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("ID")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.adminDetail.id))])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Nama")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.adminDetail.name))])]), _vm._m(0), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Role")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.adminDetail.role))])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Permission")]), _vm._l(_vm.adminDetail.permissions, function (permission) {
    return _c('p', {
      key: permission.id,
      staticClass: "text-neutral-500 mb-1"
    }, [_vm._v(_vm._s(permission.id))]);
  })], 2), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Alamat Email")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.adminDetail.email))])])]), _c('div', {
    staticClass: "flex-1 mdmax:flex-auto mdmax:w-full"
  })]), _c('div', {
    staticClass: "flex gap-6 p-6 justify-end"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Hapus",
      "type": "delete",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.submit();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Edit",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.edit();
      }
    }
  })], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("No Handphone")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v("-")])]);

}]

export { render, staticRenderFns }